var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1044_373)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4419 0.795898C8.69103 0.795898 0 9.551 0 20.3823C0 29.0403 5.56864 36.3691 13.2938 38.963C14.2597 39.158 14.6135 38.5415 14.6135 38.023C14.6135 37.5689 14.5816 36.0125 14.5816 34.3908C9.17336 35.5584 8.04713 32.056 8.04713 32.056C7.17799 29.786 5.89019 29.2026 5.89019 29.2026C4.12007 28.0028 6.01913 28.0028 6.01913 28.0028C7.98266 28.1325 9.01298 30.0133 9.01298 30.0133C10.7509 32.9964 13.5513 32.1535 14.6779 31.6346C14.8387 30.3698 15.3541 29.4943 15.9013 29.008C11.5878 28.5539 7.04945 26.8678 7.04945 19.3444C7.04945 17.2042 7.82149 15.4531 9.04482 14.0913C8.85181 13.605 8.17567 11.5941 9.23822 8.90273C9.23822 8.90273 10.8798 8.38379 14.5812 10.9132C16.1659 10.4845 17.8002 10.2664 19.4419 10.2645C21.0835 10.2645 22.7569 10.4918 24.3022 10.9132C28.004 8.38379 29.6456 8.90273 29.6456 8.90273C30.7081 11.5941 30.0316 13.605 29.8386 14.0913C31.0941 15.4531 31.8343 17.2042 31.8343 19.3444C31.8343 26.8678 27.296 28.5213 22.9503 29.008C23.6587 29.6241 24.2699 30.7913 24.2699 32.6398C24.2699 35.2663 24.2381 37.3743 24.2381 38.0226C24.2381 38.5415 24.5923 39.158 25.5577 38.9634C33.2829 36.3687 38.8516 29.0403 38.8516 20.3823C38.8834 9.551 30.1605 0.795898 19.4419 0.795898Z",
    fill: "#B0AFAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1044_373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 38.2041,
    fill: "white",
    transform: "translate(0 0.795898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.896a0daab7bea4abdd7cc222ead5380f.svg";
export { ForwardRef as ReactComponent };